import {
  ACTIVE_BILLING_FEATURES,
  BILLING_FEATURES,
  type BillingFeature,
} from "@polifonia/interlude/billingConstants";
import { useGateValue } from "@statsig/react-bindings";

const ALL_BILLING_FEATURES: ReadonlySet<BillingFeature> =
  new Set<BillingFeature>(BILLING_FEATURES);

export const useActiveBillingFeatures = (): ReadonlySet<BillingFeature> => {
  const enableAll = useGateValue("enable_frontend_all_billing_features");
  return enableAll ? ALL_BILLING_FEATURES : ACTIVE_BILLING_FEATURES;
};
